/**
*@Author zhoutong
*@Date 2022-11-04
*@Project WebStorm-admin-feature-cooperation-manage
*/
<template>
  <div class="Home-container">
    <div class="part-top-inner" ref="partTop">
      <tabs :tabsData="tabsData"
            ref="tabsRef"
            @tabsClickEvent="getTabsClickEvent"
            @setEvent="getSetEvent"
            @setAllRead="setAllRead"
            :active="active">
          <component
              :data="data"
              :isHandle="params.messageStatus === 'TODO'"
              @setRead="setRead"
              @handleSelectionChange="handleSelectionChange"
              :loading="loading"
              :is="CP[active]"></component>
          <div class="pagination-container">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,30,50]"
                :current-page="params.current"
                :page-size="params.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
          </div>
      </tabs>
    </div>
    <div class="title">
      快捷入口
    </div>
    <div class="part-bottom-inner">
     <div class="enter-item" v-for="(i,index) in enterData"
          @click="jumpEvent(i)"
          :key="index">
       <img :src="i.icon" alt="">
       <div class="text">{{i.name}}</div>
     </div>
   </div>
  </div>
</template>

<script>
import Tabs from "./Tabs.vue";
import providerLib from '@/common/images/provider-lib.svg'
import providerKc from '@/common/images/provider-kc.svg'
import providerJh from '@/common/images/provider-jh.svg'
import TodoTable from "./HomeCp/TodoTable";
import MsgTable from "./HomeCp/MsgTable";
import WaitTable from "./HomeCp/WaitTable";
import {
  getProvMessagePageTodo,
  getProvMessagePageDone,
  getProvMessageMessageCount,
  getProvMessageDoneBatch,
  getProvMessageMessagePage
} from "@/api/modules/home";
const APP_NAME = process.env.VUE_APP_NAME;
export default {

  name: "Home",

  props: {},
  components: {
    Tabs
  },

  data() {
    return {
      CP:[
        TodoTable,
        MsgTable,
        WaitTable
      ],
      loading:false,
      tableHeight:'',
      enterData:[
        {
          icon:providerLib,
          name:'供应商库',
          url:'provider-lib'
        },
        {
          icon:providerKc,
          name:'供应商考察',
          url:'supplierInspectList'
        },
        {
          icon:providerJh,
          name:'招募计划',
          url:'AP-supplier-recruit'
        }
      ],
      params:{
        size:10,
        current:1,
        userId:'',
        keyWord:'',
        timeLevel:'',
        messageType:'',
        messageStatus:'TODO'
      },
      multipleSelection:[],
      total:0,
      active:0,
      data:[],
      tabsData:[
        {
          tabName: '待办',
          active: 0,
          count:'',
          keyPress:'TODO'
        },
        {
          tabName: '消息通知',
          active: 1,
          count:'',
          keyPress:'MSG'
        },
        {
          tabName: '已办',
          active: 2,
          count:''
        }
      ],
    }
  },

  watch: {},

  mounted() {
    this.getData({})
    this.getMsgCount('TODO')
    this.getMsgCount('MSG')
  },

  methods: {
    getMsgCount(messageType){
    const userId = window._Newhope.store.state.user.oauth.userId
      getProvMessageMessageCount({
        userId,
        messageType
      }).then(res=>{
        if(res?.body){
          this.tabsData.forEach(item=>{
            if(item.keyPress === messageType){
              item.count = res.body.todo
            }
          })
        }
      })
    },
    handleSelectionChange(val){
      this.multipleSelection = val
    },
    setAllRead(){
      const row = {
        id:this.data.map(item=>item.id).join(',')
      }
      this.setRead(row)
    },
    setRead(row){
      const userId = window._Newhope.store.state.user.oauth.userId
      getProvMessageDoneBatch({
        id:row.id,
        userId
      }).then(()=>{
        this.getData({})
        this.getMsgCount('MSG')
      })
    },
    getData(prams){
      this.loading = true
      this.params.userId = window._Newhope.store.state.user.oauth.userId
      const { time,value,read } = prams
      this.params.timeLevel = time || ''
      this.params.keyWord = value || ''
      this.params.messageStatus = read || 'TODO'
      let API
      if(this.active === 0) {
        API = getProvMessagePageTodo
        this.params.messageType = 'TODO'
      }
      if(this.active === 1) {
        API = getProvMessageMessagePage
        delete this.params.messageType
      }
      if(this.active === 2) {
        API = getProvMessagePageDone
        this.params.messageType = 'TODO'
      }
      API(this.params).then(res=>{
        if(res?.body){
          this.data = res.body.records || []
          this.total = res.body.total
        }
      }).finally(()=>{
        this.loading = false
      })
    },
    jumpEvent(v){
      this.$router.push({
        name: `${APP_NAME}.${v.url}`
      });
    },
    handleSizeChange(v){
      this.params.size = v
      // this.getData({})
      this.$refs.tabsRef.event(0, false)
    },
    handleCurrentChange(v){
      this.params.current = v
      // this.getData({})
      this.$refs.tabsRef.event(0, false)
    },
    getSetEvent(v){
      // this.params.current = 1
      // this.params.size = 10
      // if(v.type === 1){
      //   this.getMsgCount('TODO')
      // }
      const { refresh, ...rest } = v
      if(refresh){
        this.params.current = 1
        this.params.size = 10
        if(v.type === 1){
          this.getMsgCount('TODO')
        }
      }
      this.getData(rest)

      // this.getData(v)
    },
    getTabsClickEvent(v){
      this.active = v
      this.params.current = 1
      if(this.active === 0){
        this.getMsgCount('TODO')
      } else if (this.active === 1) {
        this.getMsgCount('MSG')
      }
      this.$refs.tabsRef.clearData()
      this.getData({});
    }
  },

}
</script>

<style scoped lang="scss">
.Home-container {
  height: 100%;
  display: flex;
  flex-flow: column;
  .pagination-container {
    text-align: right;
    padding: 10px 0 10px 0;
  }
  .part-top-inner{

  }
  .title {
    height: 44px;
    border-bottom: 1px solid #eee;
    display: flex;
    padding-left: 8px;
    align-items: center;
    font-size: 14px;
    color: #666;
  }
  .part-bottom-inner {
    padding: 20px;
    display: flex;
    margin-left: -50px;
    flex: 1;
    .enter-item {
      cursor: pointer;
      img{
        width: 40px;
        height: 40px;
      }
      .text{
        margin-top: 8px;
        color: #666;
      }
      font-size: 14px;
      display: flex;
      flex-flow: column;
      align-items: center;
      margin-left: 50px;
    }
  }
}
</style>